export async function fileToCompressedDataUrl(
  file: File,
  maxSize = 512,
  quality = 0.85,
): Promise<string> {
  if (!file.type.startsWith('image/')) {
    throw new Error('Nur Bilddateien werden unterstützt.');
  }
  const bitmap = await createImageBitmap(file);
  const scale = Math.min(1, maxSize / Math.max(bitmap.width, bitmap.height));
  const w = Math.round(bitmap.width * scale);
  const h = Math.round(bitmap.height * scale);
  const canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas nicht verfügbar.');
  ctx.drawImage(bitmap, 0, 0, w, h);
  bitmap.close?.();
  return canvas.toDataURL('image/jpeg', quality);
}

export async function fileToBitmap(file: File): Promise<ImageBitmap> {
  if (!file.type.startsWith('image/')) {
    throw new Error('Nur Bilddateien werden unterstützt.');
  }
  // Handykameras legen die Drehung nur als EXIF-Flag ab — ohne 'from-image' liegen Hochformate quer.
  return createImageBitmap(file, { imageOrientation: 'from-image' });
}

export interface CropRect {
  /** Quell-Rechteck im Bild in Bild-Pixeln; immer quadratisch. */
  sx: number;
  sy: number;
  size: number;
}

export function cropToDataUrl(
  bitmap: ImageBitmap,
  rect: CropRect,
  outSize = 512,
  quality = 0.85,
): string {
  const canvas = document.createElement('canvas');
  canvas.width = outSize;
  canvas.height = outSize;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas nicht verfügbar.');
  ctx.imageSmoothingQuality = 'high';
  ctx.drawImage(
    bitmap,
    rect.sx,
    rect.sy,
    rect.size,
    rect.size,
    0,
    0,
    outSize,
    outSize,
  );
  return canvas.toDataURL('image/jpeg', quality);
}
